import type { CardsFulfillmentStatus } from '@dock/types-dock-partner';

import cardDetailsLang from '../../../lang/cardDetails';

export const physicalCardStatusMap: Record<CardsFulfillmentStatus, string> = {
    ISSUED: cardDetailsLang.PHYSICAL_CARD_STATUS.ISSUED,
    ORDERED: cardDetailsLang.PHYSICAL_CARD_STATUS.ORDERED,
};
